import comp from '../components/barrel';

const CONTACT_EP = 'advisors/record-advisor-contact';
const LEAD_CONTACT_EP = 'advisors/record-lead-contact';

function todayISODate() {
  const d = new Date();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
}

function addDaysISODate(days) {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() + days);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
}

function firstWorkingDayAfterDays(days) {
  const d = new Date();
  d.setHours(12, 0, 0, 0);
  d.setDate(d.getDate() + days);
  const weekday = d.getDay();
  if (weekday === 6) d.setDate(d.getDate() + 2);
  else if (weekday === 0) d.setDate(d.getDate() + 1);
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${d.getFullYear()}-${month}-${day}`;
}

function setFieldFeedback(el, message) {
  if (!el) return;
  const fb = document.querySelector(`[fb-for="${el.id}"]`);
  if (fb) fb.textContent = message || '';
  if (message) el.classList.add('input-error');
  else el.classList.remove('input-error');
}

const LEAD_MOTIVATIONS = [
  {value: 'First contact', label: 'First contact'},
  {value: 'Follow up', label: 'Follow up'},
];

const ADVISOR_GROUP_MOTIVATIONS = [
  'Courtesy call',
  'New Product / Services',
  'Complaint – Estate',
  'Complaint – Trust',
  'Complaint – Other',
  'Enquiry – Estate',
  'Enquiry – Will',
  'Enquiry – Commission',
  'Enquiry – Trust',
  'Enquiry – Other',
  'Estate Intake',
  'Other',
].map((label) => ({value: label, label}));

const PHONE_MEDIUM = 'Phone call';

const TELEPHONIC_OUTCOMES = [
  'No Answer / Voicemail',
  'Inhouse',
  'External',
  'Not interested',
  'Requested more information',
].map((label) => ({value: label, label}));

function referralKind(motivation) {
  const value = String(motivation || '').trim();
  if (value.indexOf('Complaint') === 0) return 'complaint';
  if (value.indexOf('Enquiry') === 0) return 'enquiry';
  return '';
}

const REFERRAL_NAME_LABELS = {
  complaint: 'Name of Estate/ Trust',
  enquiry: 'Name of Estate/ Trust / Client name',
};

const advisorContactReportForm = {
  target: {},
  onSuccess: null,

  async open({advisor_user_id, d_advisor_group_id, h_advisor_group_id, onSuccess, lead_uuid, mode, fromAdvisorGroup} = {}) {
    const existing = U.id('contactReportModal');
    if (existing) existing.remove();

    const isLead = mode === 'lead' || !!lead_uuid;
    this.target = {
      advisor_user_id,
      d_advisor_group_id,
      h_advisor_group_id,
      lead_uuid,
      mode: isLead ? 'lead' : 'advisor',
      fromAdvisorGroup: !isLead && !!fromAdvisorGroup,
    };
    this.onSuccess = typeof onSuccess === 'function' ? onSuccess : null;
    this.defaultFollowUpDate = firstWorkingDayAfterDays(14);

    const overlay = U.divAtt('div', 'class', 'fixed inset-0 z-50 overflow-y-auto bg-opacity-50 bg-black');
    overlay.id = 'contactReportModal';

    const card = U.divAtt('div', 'class', 'card relative transform overflow-hidden mx-auto my-8 max-w-2xl');
    const title = document.createElement('h4');
    title.textContent = 'Contact report';
    card.appendChild(title);

    const form = U.divAtt('div', 'id', 'contactReportForm');

    const motivationOpts = isLead ? LEAD_MOTIVATIONS : ADVISOR_GROUP_MOTIVATIONS;

    form.appendChild(
      await comp.select_v2({
        elID: 'contactMotivation',
        ddData: motivationOpts,
        valueDataName: 'value',
        textDataName: 'label',
        labelName: 'Motivation of contact',
        requiredYN: 1,
        onchange: isLead ? '' : 'advisorContactReportForm.onMotivationChange()',
      })
    );

    if (!isLead) {
      const referral = U.divAtt('div', 'id', 'contactReferralFields');
      referral.style.display = 'none';
      referral.appendChild(await comp.inputText('contactReferralName', '', REFERRAL_NAME_LABELS.complaint, 0, '', ''));
      referral.appendChild(await comp.inputDate('contactReferDate', '', 'Refer date', 0));
      referral.appendChild(await comp.inputText('contactReferredTo', '', 'Referred to', 0, '', ''));
      form.appendChild(referral);
    }
    const mediumOpts = [
      {value: 'Email', label: 'Email'},
      {value: 'Phone call', label: 'Phone call'},
      {value: 'In person', label: 'In person'},
      {value: 'Teams', label: 'Teams'},
      {value: 'Other', label: 'Other'},
    ];

    form.appendChild(
      await comp.select_v2({
        elID: 'contactMedium',
        ddData: mediumOpts,
        valueDataName: 'value',
        textDataName: 'label',
        labelName: 'Medium of contact',
        requiredYN: 1,
        onchange: 'advisorContactReportForm.onMediumChange()',
      })
    );
    const outcomeWrap = U.divAtt('div', 'id', 'contactTelephonicOutcomeWrap');
    outcomeWrap.style.display = 'none';
    outcomeWrap.appendChild(
      await comp.select_v2({
        elID: 'contactTelephonicOutcome',
        ddData: TELEPHONIC_OUTCOMES,
        valueDataName: 'value',
        textDataName: 'label',
        labelName: 'Telephone call outcome',
        requiredYN: 0,
      })
    );
    form.appendChild(outcomeWrap);
    form.appendChild(await comp.inputDate('contactDate', todayISODate(), 'Date of contact', 1));
    form.appendChild(await comp.textarea('contactNotes', '', 'Notes', 1));
    const followUpField = await comp.inputDate('contactFollowUpDate', this.defaultFollowUpDate, 'Follow up date', 1);
    const followUpInput = followUpField.querySelector('#contactFollowUpDate');
    if (followUpInput) {
      followUpInput.min = todayISODate();
      followUpInput.max = addDaysISODate(30);
      followUpInput.addEventListener('change', () => this.onFollowUpDateChange());
    }
    form.appendChild(followUpField);
    const longerWrap = U.divAtt('div', 'id', 'contactFollowUpLongerWrap');
    longerWrap.style.display = 'none';
    longerWrap.appendChild(
      await comp.inputText('contactFollowUpLongerReason', '', 'Reason follow up is longer than 2 weeks', 0)
    );
    form.appendChild(longerWrap);
    form.appendChild(await comp.textarea('contactFollowUpAction', '', 'Follow up action', 0));
    form.appendChild(
      await comp.inputCheckbox(
        'retireAdvisorRecord',
        0,
        isLead ? 'Retire lead' : 'Retire advisor record',
        'advisorContactReportForm.onRetireAdvisorChange()'
      )
    );
    form.appendChild(await comp.textarea('retireAdvisorReason', '', 'Reason to retire record', 0));

    card.appendChild(form);

    const actions = U.divAtt('div', 'class', 'flex justify-center items-center gap-4 mt-4');
    const cancelBtn = document.createElement('button');
    cancelBtn.type = 'button';
    cancelBtn.className = 'btn-outline';
    cancelBtn.textContent = 'Cancel';
    cancelBtn.setAttribute('onclick', "U.closeModal('contactReportModal')");

    const recordBtn = document.createElement('button');
    recordBtn.type = 'button';
    recordBtn.className = 'btn';
    recordBtn.id = 'recordAdvisorContactBtn';
    recordBtn.textContent = 'Record';
    recordBtn.setAttribute('onclick', 'advisorContactReportForm.submitAdvisorContactReport()');

    actions.appendChild(cancelBtn);
    actions.appendChild(recordBtn);
    card.appendChild(actions);
    overlay.appendChild(card);
    document.body.prepend(overlay);
  },

  onFollowUpDateChange() {
    const followUp = U.id('contactFollowUpDate');
    const wrap = U.id('contactFollowUpLongerWrap');
    const reason = U.id('contactFollowUpLongerReason');
    if (!wrap || !reason) return;
    const chosen = followUp ? String(followUp.value || '').trim() : '';
    const show = (this.target || {}).mode === 'lead' && !!chosen && chosen > this.defaultFollowUpDate;
    wrap.style.display = show ? '' : 'none';
    if (show) reason.setAttribute('required', '');
    else {
      reason.removeAttribute('required');
      reason.value = '';
      setFieldFeedback(reason, '');
    }
  },

  onMediumChange() {
    const medium = U.id('contactMedium');
    const wrap = U.id('contactTelephonicOutcomeWrap');
    const outcome = U.id('contactTelephonicOutcome');
    if (!wrap || !outcome) return;
    const show = (this.target || {}).mode === 'lead' && !!(medium && String(medium.value || '').trim() === PHONE_MEDIUM);
    wrap.style.display = show ? '' : 'none';
    if (show) outcome.setAttribute('required', '');
    else {
      outcome.removeAttribute('required');
      outcome.value = '';
      setFieldFeedback(outcome, '');
    }
  },

  onMotivationChange() {
    const motivation = U.id('contactMotivation');
    const wrap = U.id('contactReferralFields');
    if (!wrap) return;
    const kind = referralKind(motivation && motivation.value);
    const show = !!kind;
    wrap.style.display = show ? '' : 'none';
    const nameLabel = document.querySelector('label[for="contactReferralName"]');
    if (nameLabel && REFERRAL_NAME_LABELS[kind]) nameLabel.textContent = REFERRAL_NAME_LABELS[kind];
    ['contactReferralName', 'contactReferDate', 'contactReferredTo'].forEach((id) => {
      const el = U.id(id);
      if (!el) return;
      if (show) el.setAttribute('required', '');
      else {
        el.removeAttribute('required');
        el.value = '';
        setFieldFeedback(el, '');
      }
    });
  },

  onRetireAdvisorChange() {
    const reason = U.id('retireAdvisorReason');
    const checked = !!(U.id('retireAdvisorRecord') && U.id('retireAdvisorRecord').checked);
    if (!reason) return;
    if (checked) reason.setAttribute('required', '');
    else {
      reason.removeAttribute('required');
      setFieldFeedback(reason, '');
    }
  },

  async submitAdvisorContactReport() {
    const target = this.target || {};
    const motivation = U.id('contactMotivation');
    const medium = U.id('contactMedium');
    const telephonicOutcome = U.id('contactTelephonicOutcome');
    const contactDate = U.id('contactDate');
    const notes = U.id('contactNotes');
    const followUpDate = U.id('contactFollowUpDate');
    const longerReason = U.id('contactFollowUpLongerReason');
    const followUpAction = U.id('contactFollowUpAction');
    const retire = U.id('retireAdvisorRecord');
    const retireReason = U.id('retireAdvisorReason');
    const referralName = U.id('contactReferralName');
    const referDate = U.id('contactReferDate');
    const referredTo = U.id('contactReferredTo');

    [motivation, medium, telephonicOutcome, contactDate, notes, followUpDate, longerReason, followUpAction, retireReason, referralName, referDate, referredTo].forEach((el) =>
      setFieldFeedback(el, '')
    );

    const isLead = target.mode === 'lead';
    let valid = true;
    if (!motivation || !String(motivation.value || '').trim()) {
      setFieldFeedback(motivation, 'Cannot be empty');
      valid = false;
    }
    const mediumVal = medium ? String(medium.value || '').trim() : '';
    if (!mediumVal) {
      setFieldFeedback(medium, 'Cannot be empty');
      valid = false;
    }
    const phoneCall = isLead && mediumVal === PHONE_MEDIUM;
    const telephonicOutcomeVal = telephonicOutcome ? String(telephonicOutcome.value || '').trim() : '';
    if (phoneCall && !telephonicOutcomeVal) {
      setFieldFeedback(telephonicOutcome, 'Cannot be empty');
      valid = false;
    }
    if (!contactDate || !String(contactDate.value || '').trim()) {
      setFieldFeedback(contactDate, 'Cannot be empty');
      valid = false;
    }
    const notesVal = notes ? String(notes.value || '').trim() : '';
    if (notesVal.length < 10) {
      setFieldFeedback(notes, 'Notes must be at least 10 characters');
      valid = false;
    }

    const followUpVal = followUpDate ? String(followUpDate.value || '').trim() : '';
    const followUpMin = todayISODate();
    const followUpMax = addDaysISODate(30);
    if (!followUpVal) {
      setFieldFeedback(followUpDate, 'Cannot be empty');
      valid = false;
    } else if (followUpVal < followUpMin || followUpVal > followUpMax) {
      setFieldFeedback(followUpDate, 'Choose a date from today up to 30 days ahead');
      valid = false;
    }
    const longerFollowUp = isLead && !!followUpVal && followUpVal > this.defaultFollowUpDate;
    const longerReasonVal = longerReason ? String(longerReason.value || '').trim() : '';
    if (longerFollowUp && !longerReasonVal) {
      setFieldFeedback(longerReason, 'Cannot be empty');
      valid = false;
    }

    const retireYn = !!(retire && retire.checked);
    const retireReasonVal = retireReason ? String(retireReason.value || '').trim() : '';
    if (retireYn && retireReasonVal.length < 20) {
      setFieldFeedback(retireReason, 'Reason must be at least 20 characters');
      valid = false;
    }

    const motivationVal = motivation ? String(motivation.value || '').trim() : '';
    const referralType = referralKind(motivationVal);
    const showReferral = !isLead && !!referralType;
    const referralNameVal = referralName ? String(referralName.value || '').trim() : '';
    const referDateVal = referDate ? String(referDate.value || '').trim() : '';
    const referredToVal = referredTo ? String(referredTo.value || '').trim() : '';
    if (showReferral) {
      if (!referralNameVal) {
        setFieldFeedback(referralName, 'Cannot be empty');
        valid = false;
      }
      if (!referDateVal) {
        setFieldFeedback(referDate, 'Cannot be empty');
        valid = false;
      }
      if (!referredToVal) {
        setFieldFeedback(referredTo, 'Cannot be empty');
        valid = false;
      }
    }

    if (!valid) return;

    const endpoint = isLead ? LEAD_CONTACT_EP : CONTACT_EP;
    const vars = {
      motivation_of_contact: String(motivation.value).trim(),
      medium_of_contact: mediumVal,
      date_of_contact: String(contactDate.value).trim(),
      notes: notesVal,
      follow_up_date: followUpVal,
      follow_up_action:
        followUpAction && String(followUpAction.value || '').trim() ? String(followUpAction.value).trim() : null,
      reason_to_retire: retireYn ? retireReasonVal : null,
    };
    if (isLead) {
      vars.lead_uuid = target.lead_uuid;
      vars.retire_lead = retireYn;
      vars.telephonic_outcome = phoneCall ? telephonicOutcomeVal : null;
      vars.follow_up_more_than_2_weeks = longerFollowUp ? longerReasonVal : null;
    } else {
      vars.h_advisor_group_id = target.h_advisor_group_id != null ? parseInt(target.h_advisor_group_id, 10) : null;
      vars.advisor_user_id = target.advisor_user_id != null ? parseInt(target.advisor_user_id, 10) : null;
      vars.d_advisor_group_id = target.d_advisor_group_id != null ? parseInt(target.d_advisor_group_id, 10) : null;
      vars.retire_advisor_record = retireYn;
      if (showReferral) {
        vars.referral_name = referralNameVal;
        vars.refer_date = referDateVal;
        vars.referred_to = referredToVal;
      }
    }

    try {
      const res = await O.PREP([await O.mPOST(endpoint, vars)]);
      const result = res[endpoint] || {};
      if (result.status === 'OK') {
        U.closeModal('contactReportModal');
        comp.toast('Contact report recorded');
        if (this.onSuccess) await this.onSuccess();
        return;
      }
      const err = result.data && result.data.error;
      comp.toast(err || 'Unable to record contact report');
    } catch (e) {
      comp.toast('Unable to record contact report');
    }
  },
};

window.advisorContactReportForm = advisorContactReportForm;

export default advisorContactReportForm;
